import { defineRecipe } from '@chakra-ui/react/styled-system'

import { EColors } from '../types'

const { persianRed, white } = EColors

export const spinnerRecipe = defineRecipe({
  className: 'chakra-spinner',
  base: {
    color: persianRed,
    borderWidth: '2px',
  },
  variants: {
    variant: {
      game: {
        width: '56px',
        height: '56px',
        color: white,
        borderWidth: '6px',
      },
    },
  },
  defaultVariants: {
    variant: undefined,
  },
})
